import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '~/componentsPage/Header/Header';
import styles from '~/styles/TermsAndConditions/TermsAndConditions.module.css';

function TermsAndConditions() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  return (
    <div className={styles.pageContainer}>
      <Header />
      {/* CONTENT REGULAMINU */}
      <main className={styles.contactContent}>
        <section className={styles.contactHero}>
          <h1>Regulamin serwisu</h1>
          <p>Zasady korzystania z portalu Czateria24.pl</p>
        </section>

        <div className={styles.contactCard} style={{ textAlign: 'left', lineHeight: '1.7' }}>
          <section>
            <h3>§1. Postanowienia ogólne</h3>
            <p>Niniejszy regulamin określa zasady korzystania z serwisu Czateria24. Korzystanie z portalu jest równoznaczne z akceptacją wszystkich postanowień niniejszego regulaminu.</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>§2. Warunki korzystania</h3>
            <p>1. Serwis przeznaczony jest wyłącznie dla osób pełnoletnich (powyżej 18 roku życia).<br />
              2. Użytkownik zobowiązuje się do korzystania z serwisu w sposób zgodny z obowiązującym prawem i dobrymi obyczajami.</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>§3. Zasady zachowania</h3>
            <p>Na czacie surowo zabrania się:</p>
            <ul style={{ paddingLeft: '20px', color: 'var(--text-muted)' }}>
              <li>Obrażania innych użytkowników i stosowania mowy nienawiści.</li>
              <li>Spamowania oraz przesyłania treści reklamowych bez zgody administratora.</li>
              <li>Udostępniania danych osobowych osób trzecich.</li>
              <li>Promowania treści nielegalnych oraz pornograficznych.</li>
            </ul>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>§4. Odpowiedzialność</h3>
            <p>Administrator serwisu nie ponosi odpowiedzialności za treści publikowane przez użytkowników. Każdy użytkownik ponosi pełną odpowiedzialność za swoje wypowiedzi i działania w serwisie.</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>§5. Blokady i bany</h3>
            <p>Administrator zastrzega sobie prawo do zablokowania dostępu użytkownikowi, który łamie postanowienia niniejszego regulaminu, bez konieczności podania przyczyny.</p>
          </section>
        </div>
      </main>

      {/* FOOTER */}
      <footer className={styles.mainFooter}>
        <div className={styles.footerContent}>
          <div className={styles.footerLinks}>
            <Link to="/pomoc">Pomoc</Link>
            <Link to="/kontakt">Kontakt</Link>
            <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
            <Link to="/regulamin">Regulamin</Link>
          </div>
          <div className={styles.disclaimer}>
            <p>Serwis <strong>Czateria24</strong> jest przeznaczony wyłącznie dla osób, które ukończyły 18 lat. Korzystanie z portalu oznacza akceptację regulaminu oraz polityki cookies.</p>
          </div>
          <div className={styles.copyright}>© Czateria24. Wszystkie prawa zastrzeżone.</div>
        </div>
      </footer>
    </div>
  );
};

export default TermsAndConditions;